import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { compose, lifecycle, withHandlers, withProps } from 'recompose';
import classnames from 'classnames';
import set from 'lodash/set';
import { INDETERMINATE } from './constants';

const withIndeterminateState = compose(
  withProps(() => ({
    inputRef: React.createRef(),
  })),
  withHandlers({
    showIndeterminateStateIfSet: props => () => {
      if (!props.inputRef.current) {
        return;
      }

      const isIndeterminate = props.input.value === INDETERMINATE;

      if (props.inputRef.current.indeterminate !== isIndeterminate) {
        set(props.inputRef.current, 'indeterminate', isIndeterminate);
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.showIndeterminateStateIfSet();
    },
    componentDidUpdate() {
      this.props.showIndeterminateStateIfSet();
    },
  })
);

const Input = withIndeterminateState(({ input, id, disabled, inputRef }) => (
  <input
    {...input}
    className="c-checkbox__input"
    type="checkbox"
    id={id}
    checked={input.value}
    disabled={disabled}
    ref={inputRef}
  />
));

Input.propTypes = {
  input: PropTypes.shape({}),
  id: PropTypes.string,
  disabled: PropTypes.bool,
};

Input.defaultProps = {
  input: {},
  id: null,
  disabled: false,
};

const SimpleCheckbox = ({
  label,
  id,
  labelClass,
  name,
  disabled,
  format,
  containerClass,
  onChange,
}) => {
  if (!name) {
    return null;
  }

  return (
    <div className={classnames('c-checkbox u-mr', containerClass)}>
      <Field
        name={name}
        component={Input}
        id={id}
        disabled={disabled}
        normalize={val => val || false}
        format={format}
        onChange={onChange}
      />
      <label className="c-checkbox__label" htmlFor={id}>
        <span className="c-checkbox__trigger" />
        <span className={`c-checkbox__text ${labelClass || ''}`} display-if={label}>{label}</span>
      </label>
    </div>
  );
};

SimpleCheckbox.propTypes = {
  label: PropTypes.node,
  id: PropTypes.string,
  labelClass: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  format: Field.propTypes.format,
  containerClass: PropTypes.string,
  onChange: PropTypes.func,
};

SimpleCheckbox.defaultProps = {
  label: null,
  id: null,
  labelClass: '',
  value: false,
  disabled: false,
  format: value => (value === INDETERMINATE ? value : !!value),
  containerClass: '',
  onChange: null,
};

export default SimpleCheckbox;
